const Poll = {
    types: {
        branched: 'Oddziałowa',
        branchless: 'Bezoddziałowa',
        branch: 'Dla oddziału',
    },
};

export default Poll
